<template>
  <div class="c-event-messaging__message">
    <div class="c-message c-message--youth c-content" data-message-type="youth">
      <h3 class="c-col__heading-4">16-25s Tickets</h3>
      <div class="c-message--content" v-html="output"></div>
      <a v-if="!isYouthMOS" class="c-btn c-btn--ghost c-btn--small" :href="link">Unlock 16-25s tickets</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Youth",
  props: ['content'],
  data() {
    return {
      output: '',
      link:'',
      isYouthMOS: false,
    }
  },
  mounted() {
    this.renderContent()
  },
  methods: {
    renderContent() {
      this.output = this.content.message
      this.link = `${window.env.PICKER_BASE_URL}/events/${this.$parent.eventId}?promo=16225YO`

      if (window.ModeOfSaleId === 124) {
        this.isYouthMOS = true
      }
    }
  }
}
</script>
